import { bootstrap } from './bootstrap';

const script = (document.currentScript as HTMLScriptElement | null) ?? (() => {
  const all = document.getElementsByTagName('script');
  return all[all.length - 1] as HTMLScriptElement | null;
})();

bootstrap(script);
